import { Router } from 'next/router';
import TagManager from 'react-gtm-module-defer';

import { trackEvent } from './trackEvent';

const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID ?? '';
const IS_PROD = process.env.NODE_ENV === 'production';
const IS_CLIENT = typeof window !== 'undefined';

const handleRouteChange = (url: string) => {
  trackEvent({
    eventName: 'pageview',
    originalLocation: url,
  });
};

export const initAnalytics = () => {
  if (IS_CLIENT) {
    TagManager.initialize({ gtmId: IS_PROD ? GTM_ID : '' });
    handleRouteChange(window.location.pathname);
  }

  Router.events.on('routeChangeComplete', handleRouteChange);

  return () => {
    Router.events.off('routeChangeComplete', handleRouteChange);
  };
};
